<template>
  <ReHeight @click.stop.self.prevent>
    <div ref="toolreheight" @dblclick.stop.prevent="heightAuto" 
      style="width: 100%; height: 100%"
    >
      <ToolLabel v-if="mode == reheight_mode" class="px-2 mx-2" style="">
        W: {{ width }}, H: {{ height }}
      </ToolLabel>
    </div>
  </ReHeight>
</template>

<script>
import { mapGetters } from "vuex";

import { ReHeight, ToolLabel } from "./Reheight.styled";
import { findParentComponent } from "@helpers/component.helper";
export default {
  components: {
    ReHeight,
    ToolLabel,
  },
  data() {
    return {
      reheight_mode: "reheight_component",
      height: 0,
      width: 0,
      cellRow: [],
    };
  },
  computed: {
    ...mapGetters({
      components: "designIframe/metadata/components",
      gridActive: "designIframe/frame/gridActive",
      gridHover: "designIframe/frame/gridHover",
      mode: "designIframe/mode",
      detectDevice: "detectDevice",
    }),
    element() {
      return this.components[this.component_id];
    },

    styleDevice() {
      switch (this.detectDevice) {
        case "mobile":
          return "styleMobile";
        case "tablet":
          return "styleTablet";
        default:
          return "style";
      }
    },
  },
  props: ["component_id"],
  mounted() {
    this.dragElement();
    document.addEventListener("mouseleave", this.detectOutOfFrame, { passive: true });
  },
  methods: {
    findCellRow() {
      const element = document.getElementById(`comp-${this.component_id}`);
      this.height = element.offsetHeight;
      this.width = element.offsetWidth;
      const parent = findParentComponent(this.components, this.component_id);
      const parent_id = parent[parent.length - 1];

      const config = this.components[parent_id].componentsID.map((child_id) => {
        const child = document.getElementById(`comp-${child_id}`);
        return {
          id: child_id,
          height: child.offsetHeight,
          top: child.offsetTop,
        };
      });

      this.cellRow = config.filter(
        (item) =>
          item.height == element.offsetHeight && item.top == element.offsetTop
      );
    },
    dragElement() {
      this.$refs["toolreheight"].onmousedown = this.dragMouseDown;
    },
    dragMouseDown(e) {
      e = e || window.event;
      this.$store.dispatch("design/setMode", {
        mode: this.reheight_mode,
      });
      e.preventDefault();
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      document.onmouseup = this.closeDragElement;
      document.onmousemove = this.elementDrag;
      this.findCellRow();
    },

    elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      const position = document.getElementById(`comp-${this.component_id}`);
      this.height = position.offsetHeight;
      this.pos1 = this.pos3 - e.clientX;
      this.pos2 = this.pos4 - e.clientY;
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;

      this.cellRow.forEach((child) => {
        if (this.components[child.id]) {
          this.components[child.id][this.styleDevice].height =
            (position.offsetHeight +
            this.$refs["toolreheight"].offsetTop -
            this.pos2) > 30 ? position.offsetHeight +
            this.$refs["toolreheight"].offsetTop -
            this.pos2 : 30;
        }
      });
      this.$nextTick(() => {
        this.$store.dispatch("designIframe/frame/reRenderFrame");
      });
    },

    closeDragElement() {
      this.$store.dispatch("designIframe/snapshot/genSnapshot");
      this.$store.dispatch("design/setMode", {});
      document.onmouseup = null;
      document.onmousemove = null;
    },
    heightAuto() {
      this.cellRow.forEach((child) => {
        if (this.components[child.id]) {
          this.components[child.id][this.styleDevice].height = "auto";
        }
      });
      this.$nextTick(() => {
        this.$store.dispatch("designIframe/frame/reRenderFrame");
      });
      this.$store.dispatch("designIframe/snapshot/genSnapshot");
    },
    detectOutOfFrame(e) {
      if(e.clientY <= 0 || e.clientX <= 0 || (e.clientX >= window.innerWidth || e.clientY >= window.innerHeight))
      {
        this.closeDragElement()
      }
    },
  },
};
</script>

<style>
</style>